<template>
  <div class="admin-html-settings">
    <h1>相關設置</h1>

    <!-- 運費設置按鈕 -->
    <button class="btn-open-modal" @click="openShippingModal">運費設置</button>
    <!-- 付款類型按鈕 -->
    <button class="btn-open-modal" @click="openPaymentModal">付款類型</button>

    <!-- 運費設置彈跳視窗 -->
    <div v-if="showShippingModal" class="modal-backdrop">
      <div class="modal-content">
        <button class="modal-close-btn" @click="closeShippingModal">×</button>
        <h2>運費設置</h2>
        <div class="table-container responsive-table">
          <table>
          <thead>
            <tr>
              <th>啟用</th>
              <th>圖示</th>
              <th>圖址</th>
              <th>名稱</th>
              <th>費用</th>
              <th>免運門檻</th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="(method) in shipping_methods" :key="method.id">
              <td data-label="啟用">
                <label class="switch">
                  <input
                    type="checkbox"
                    v-model="method.is_active"
                    :true-value="1"
                    :false-value="0"
                     @change="onMethodStatusChange(method)"
                  />
                  <span class="slider"></span>
                </label>
              </td>
              <td data-label="圖示">
                <!--img 置中-->
                <img :src="method.icon_url" alt="運費圖示" />
              </td>
              <td data-label="圖址">
                <input
                  type="text"
                  v-model="method.icon_url"
                  class="input-field"
                />
              </td>
              <td data-label="名稱">
                <input
                  type="text"
                  v-model="method.name"
                  class="input-field"
                  disabled
                />
              </td>
              <td data-label="費用">
                <input
                  type="number"
                  v-model="method.shipping_cost"
                  class="input-field"
                />
              </td>
              <td data-label="免運門檻">
                <input
                  type="number"
                  v-model="method.free_shipping_threshold"
                  class="input-field"
                />
              </td>
            </tr>
          </tbody>
        </table>
        </div>
        <button class="btn-view" @click="saveShippingMethod()">保存</button>
        <button class="btn-close-modal" @click="closeShippingModal">關閉</button>
      </div>
    </div>

  <!-- 付款類型彈跳視窗 -->
  <div v-if="showPaymentModal" class="modal-backdrop">
    <div class="modal-content">
      <button class="modal-close-btn" @click="closePaymentModal">×</button>
      <h2>付款類型</h2>
      <div class="table-container">
        <table class="payment-methods-table">
          <thead>
            <tr>
              <th>啟用</th>
              <th>標籤</th>
            </tr>
          </thead>
          <tbody>
            <tr
              v-for="(payment) in payment_methods"
              :key="payment.payment_method_id"
            >
              <!-- 注意：加上 data-label 以便在手機版顯示欄位名稱 -->
              <td data-label="啟用">
                <label class="switch">
                  <input
                    type="checkbox"
                    v-model="payment.status"
                    :true-value="1"
                    :false-value="0"
                    @change="onPaymentStatusChange(payment)"
                  />
                  <span class="slider"></span>
                </label>
              </td>
              <td data-label="標籤">
                <input
                  type="text"
                  v-model="payment.method_label"
                  class="input-field"
                  disabled
                />
              </td>
            </tr>
          </tbody>
        </table>
      </div>
      <button class="btn-close-modal" @click="closePaymentModal">關閉</button>
    </div>
  </div>


    <!-- 功能開關 -->
    <div class="settings-section">
      <h2>功能開關</h2>
      <div v-for="setting in featureToggles" :key="setting.id" class="setting-item">
        <label class="setting-title">{{ setting.title }}</label>
        <label class="switch">
          <input
            type="checkbox"
            :checked="setting.s_value === '1'"
            @change="onToggleChange(setting, $event)"
          />
          <span class="slider"></span>
        </label>
      </div>
    </div>

    <!-- 一般設定資料 -->
    <div class="settings-section">
      <h2>一般設定資料</h2>
      <div v-if="generalSettings.length" class="settings-container">
        <div
          class="setting-item"
          v-for="(setting, index) in generalSettings"
          :key="index"
        >
          <label class="setting-title">{{ setting.title }}</label>
          <div class="setting-input">
            <input
              type="text"
              v-model="setting.s_value"
              class="input-field"
            />
          </div>
          <button class="btn-view" @click="updateSetting(setting)">更新</button>
        </div>
      </div>
      <div v-else>
        <p>請稍後..</p>
      </div>
    </div>
  </div>
</template>

<script setup>
import { ref, computed, onMounted, onUnmounted, watch } from 'vue'
import { useRouter } from 'vue-router'
import { useAdminSysTempStore } from '@/store/adminSysTempStore.js'
import axios from 'axios'
import Swal from 'sweetalert2'

const router = useRouter()

const TOGGLE_KEYS = ['BOOKING_ENABLED']

const settings = ref([])
const payment_methods = ref([])
const shipping_methods = ref([])

const featureToggles = computed(() => settings.value.filter(s => TOGGLE_KEYS.includes(s.s_key)))
const generalSettings = computed(() => settings.value.filter(s => !TOGGLE_KEYS.includes(s.s_key)))

// 控制彈跳視窗
const showShippingModal = ref(false)
const showPaymentModal = ref(false)

// 當彈跳視窗開啟時停止背景捲動
function disableBodyScroll() {
  document.body.classList.add('noscroll')
}
function enableBodyScroll() {
  document.body.classList.remove('noscroll')
}

function openShippingModal() {
  showShippingModal.value = true
}

function closeShippingModal() {
  showShippingModal.value = false
}

function openPaymentModal() {
  showPaymentModal.value = true
}

function closePaymentModal() {
  showPaymentModal.value = false
}

// 監聽 showPaymentModal
watch(showPaymentModal, (newVal) => {
  if (newVal) {
    disableBodyScroll()
  } else {
    // 如果運費彈窗也沒開，再解鎖
    if (!showShippingModal.value) {
      enableBodyScroll()
    }
  }
})
// 監聽 showShippingModal
watch(showShippingModal, (newVal) => {
  if (newVal) {
    disableBodyScroll()
  } else {
    if (!showPaymentModal.value) {
      enableBodyScroll()
    }
  }
})

// 監聽鍵盤事件，按 ESC 關閉彈窗
function handleEsc(e) {
  if (e.key === 'Escape') {
    if (showShippingModal.value) {
      closeShippingModal()
    }
    if (showPaymentModal.value) {
      closePaymentModal()
    }
  }
}

// 取得資料 (包含 shipping_methods, payment_methods, settings)
async function Loadsettings() {
  try {
    const { data } = await axios.get('/api/admin/loadsettings')
    if (data.success) {
      settings.value = data.settings || []
      payment_methods.value = data.payment_methods || []
      shipping_methods.value = data.shipping_methods || []
    } else {
      console.error(data.message)
    }
  } catch (err) {
    console.error('取得 Loadsettings 資料失敗:', err)
  }
}

// 功能開關
async function onToggleChange(setting, event) {
  setting.s_value = event.target.checked ? '1' : '0'
  await updateSetting(setting, true)
}

// 更新一般設定（silent=true 時不顯示成功彈窗）
async function updateSetting(setting, silent = false) {
  try {
    const { data } = await axios.post('/api/admin/updatesettings', {
      s_id: setting.id,
      s_value: setting.s_value,
    })
    if (data.success) {
      if (!silent) Swal.fire('更新成功', '', 'success')
    } else {
      Swal.fire('更新失敗', data.message, 'error')
    }
  } catch (err) {
    console.error('更新失敗:', err)
    Swal.fire('更新失敗', '請稍後再試', 'error')
  }
}

// 更新付款開關狀態
async function onPaymentStatusChange(payment) {
  // 先記錄舊值 (若要在失敗時回復)
  const oldStatus = payment.status
  // 呼叫後端更新
  try {
    // 這裡假設您已有 updatePaymentMethod，用來 axios.post()
    const { data } =  axios.post('/api/admin/updatepayment', {
      payment_method_id: payment.payment_method_id,
      status: payment.status
    })
    if (!data.success) {
      payment.status = oldStatus
      Swal.fire('更新失敗', data.message, 'error')
    }
  } catch (err) {
    // 後端或網路出錯 -> 回復舊值
    payment.status = oldStatus
    console.error('更新付款方式失敗：', err)
  }
}

// shipping_methods 更新
async function onMethodStatusChange(method) {
  // 先記錄舊值 (若要在失敗時回復)
  const oldis_active = method.is_active
  // 呼叫後端更新
  try {
    // 這裡假設您已有 updatePaymentMethod，用來 axios.post()
    const { data } =  axios.post('/api/admin/updateshipping_active', {
      id: method.id,
      is_active: method.is_active
    })
    if (!data.success) {
      method.status = oldis_active
      Swal.fire('更新失敗', data.message, 'error')
    }
  } catch (err) {
    // 後端或網路出錯 -> 回復舊值
    method.status = oldis_active
    console.error('更新付款方式失敗：', err)
  }
}

//更新運費
async function saveShippingMethod() {
  try {
    const { data } = await axios.post('/api/admin/updateshipping', {
      shipping_methods: shipping_methods.value
    })
    if (data.success) {
      Swal.fire('儲存成功', '', 'success')
    } else {
      Swal.fire('儲存失敗', data.message, 'error')
    }
  } catch (err) {
    console.error('儲存失敗:', err)
    Swal.fire('儲存失敗', '請稍後再試', 'error')
  }
}

onMounted(async () => {
  // 綁定鍵盤事件
  window.addEventListener('keydown', handleEsc)

  const useAdminSysTemp = useAdminSysTempStore()
  await useAdminSysTemp.fetchAdminCheckLogin()
  if (!useAdminSysTemp.isLoggedIn) {
    router.push('/admin/login')
    return
  }
  await Loadsettings()
})

onUnmounted(() => {
  // 移除鍵盤事件監聽
  window.removeEventListener('keydown', handleEsc)
})
</script>

<style scoped>
.admin-html-settings {
  background-color: #fafafa;
  padding: 1rem;
  border-radius: 6px;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.1);
  max-width: 1000px;
  margin: 0 auto;
}

.btn-open-modal {
  margin-right: 12px;
  background-color: #3498db;
  color: #fff;
  padding: 6px 12px;
  border: none;
  border-radius: 4px;
  cursor: pointer;
}
.btn-open-modal:hover {
  background-color: #2980b9;
}

.table-container {
  overflow-x: auto;
}

.input-field {
  display: block;
  width: 100%;
  max-width: 100%;
  box-sizing: border-box;
  padding: 8px 12px;
  font-size: 1rem;
  border: 1px solid #ccc;
  border-radius: 4px;
  transition: box-shadow 0.2s;
}
.input-field:focus {
  outline: none;
  border-color: #007bff;
  box-shadow: 0 0 4px rgba(0, 123, 255, 0.4);
}

.btn-view {
  padding: 6px 12px;
  border: none;
  background-color: #28a745;
  color: #fff;
  border-radius: 4px;
  cursor: pointer;
  margin-right: 8px; /* 與後面的按鈕間隔 */
}
.btn-view:hover {
  background-color: #218838;
}

/* 彈跳視窗基礎樣式 */
.modal-backdrop {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0,0,0,0.5);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 999;
}
.modal-content {
  position: relative; /* 讓右上角按鈕可用絕對定位 */
  background-color: #fff;
  padding: 1.5rem;
  border-radius: 6px;
  min-width: 300px;
  max-width: 90%;
  /* 讓彈窗本身在高度過大時可捲動 */
  max-height: 90vh;
  overflow-y: auto;
}
.btn-close-modal {
  margin-top: 1rem;
  background-color: #aaa;
  color: #fff;
  padding: 6px 12px;
  border: none;
  border-radius: 4px;
  cursor: pointer;
}
.btn-close-modal:hover {
  background-color: #888;
}

/* 右上角關閉按鈕 */
.modal-close-btn {
  position: absolute;
  top: 1rem;
  right: 1rem;
  background: none;
  border: none;
  font-size: 1.5rem;
  cursor: pointer;
  color: #666;
}
.modal-close-btn:hover {
  color: #333;
}

/* 手機版彈跳視窗內容換行與高度調整 */
@media (max-width: 768px) {
  .modal-content {
    width: 90%;
    margin: 0 10px;
    max-height: 80vh; /* 手機再調整高度 */
  }
}

/* 一般設定資料 */
.settings-section {
  margin-top: 2rem;
  background: #fff;
  padding: 16px;
  border-radius: 6px;
}
.settings-container {
  display: flex;
  flex-direction: column;
  gap: 1rem;
}
.setting-item {
  display: flex;
  align-items: center;
  gap: 1rem;
  flex-wrap: wrap;
  border: 1px solid #e5e5e5;
  padding: 8px;
  border-radius: 4px;
  background: #f9f9f9;
}
.setting-title {
  flex-shrink: 0;
  width: 200px;
  font-weight: bold;
  color: #333;
}
.setting-input {
  flex: 1;
}

/* 手機版設定區域 */
@media (max-width: 768px) {
  .responsive-table table,
  .responsive-table table tbody,
  .responsive-table table tr,
  .responsive-table table td {
    display: block;
    width: 100%;
    margin: 0 auto;
    text-align: center;
  }
  table thead {
    display: none;
  }
  table tr {
    margin-bottom: 1rem;
    border-bottom: 2px solid #eee;
  }
  table td {
    border: none;
    border-bottom: 1px solid #eee;
    position: relative;
    padding-left: 40%;
    min-height: 40px;
    box-sizing: border-box;
    white-space: pre-wrap;
  }
  table td::before {
    content: attr(data-label);
    position: absolute;
    left: 12px;
    width: 35%;
    font-weight: bold;
    white-space: nowrap;
  }
  .table-container table td input[type="text"] {
    width: 100%;
  }
  .settings-item {
    display: block;
  }
  .setting-item {
    flex-direction: column;
    align-items: flex-start;
  }
  .setting-title {
    width: 100%;
    margin-bottom: 4px;
  }
}

/* 開關 */
.switch {
  position: relative;
  display: inline-block;
  width: 40px;
  height: 22px;
  margin-left: 8px;
  vertical-align: middle;
}
.switch input {
  opacity: 0;
  width: 0;
  height: 0;
}
.slider {
  position: absolute;
  cursor: pointer;
  top: 0; left: 0; right: 0; bottom: 0;
  background-color: #ccc;
  transition: .4s;
  border-radius: 34px;
}
.slider:before {
  position: absolute;
  content: "";
  height: 16px;
  width: 16px;
  left: 3px;
  bottom: 3px;
  background-color: white;
  transition: .4s;
  border-radius: 50%;
}
input:checked + .slider {
  background-color: #2196F3;
}
input:checked + .slider:before {
  transform: translateX(18px);
}

/* 禁止背景滾動 */
.noscroll {
  overflow: hidden;
}

/* 給付款方式表格一個特殊 class，避免影響其他表格 */
.payment-methods-table {
  width: 100%;
  border-collapse: collapse;
  margin-top: 1rem;
}

.payment-methods-table th,
.payment-methods-table td {
  text-align: left;
  padding: 0.75rem;
  border-bottom: 1px solid #ddd;
}

/* 手機 RWD */
@media (max-width: 768px) {
  /* 隱藏標題列；改用 td::before 來顯示欄位名稱 */
  .payment-methods-table thead {
    display: none;
  }
  /* 讓 table, thead, tbody, tr, td 都變 block */
  .payment-methods-table,
  .payment-methods-table tbody,
  .payment-methods-table tr,
  .payment-methods-table td {
    display: block;
    width: 100%;
  }
  .payment-methods-table tr {
    margin-bottom: 1rem;
    border-bottom: 2px solid #eee; /* 可視需要留 */
  }
  .payment-methods-table td {
    position: relative;
    padding-left: 5rem; 
    /* 視情況調整，預留給 td::before 顯示「啟用」「標籤」文字 */
  }
  .payment-methods-table td::before {
    content: attr(data-label);
    position: absolute;
    left: 1rem;
    font-weight: bold;
  }
}

/* 開關按鈕 (Switch) */
.switch {
  position: relative;
  display: inline-block;
  width: 40px;
  height: 22px;
  vertical-align: middle;
}
/* 讓 input 在最上層，避免手機上無法點擊 */
.switch input {
  position: relative;
  z-index: 2;
  opacity: 0;
  width: 40px;
  height: 22px;
  margin: 0;
  cursor: pointer;
}
.slider {
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: #ccc;
  border-radius: 34px;
  transition: 0.4s;
  cursor: pointer; /* 滑過時顯示手指圖示 */
}
.slider:before {
  position: absolute;
  content: "";
  height: 16px;
  width: 16px;
  left: 3px;
  bottom: 3px;
  background-color: #fff;
  border-radius: 50%;
  transition: 0.4s;
}

/* 切換時的顏色變化 */
input:checked + .slider {
  background-color: #2196F3;
}
input:checked + .slider:before {
  transform: translateX(18px);
}
</style>
<style scoped>
:global(.noscroll) {
  overflow: hidden;
}

.table-container img {
  display: block;
  margin: 0 auto;
}
</style>
